import request from "../../request.js"
import qs from "qs";

// 编辑用户
export  function updateIvUser(data) {
	return request({
		url: "/iv-user/updateIvUser",
		method: "POST",
		data
	})
}
// 登录
export  function webUserLogin(data) {
	return request({
		url: "/ai-web/webUserLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取智能体权限
export  function getAiUserChatAuth(data) {
	return request({
		url: "/ai-user-chat/getAiUserChatAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取智能体最后一次会话
export  function getAiUserChatOne(data) {
	return request({
		url: "/ai-user-chat/getAiUserChatOne",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 智能体-保存对话
export  function addAiUserChatMsg(data) {
	return request({
		url: "/ai-user-chat-msg/addAiUserChatMsg",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体-刷新子对话
export  function deleteAiUserChat(data) {
	return request({
		url: "/ai-user-chat-msg/deleteAiUserChat",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 智能体-获取对话列表
export  function getAiUserChatList(data) {
	return request({
		url: "/ai-user-chat/getAiUserChatList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 智能体-删除对话
export  function deleteAiUserChatOne(data) {
	return request({
		url: "/ai-user-chat/deleteAiUserChat",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 智能体-创建新对话
export  function addAiUserChatOne(data) {
	return request({
		url: "/ai-user-chat/addAiUserChatOne",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 智能体-获取列表中的对话
export  function getAiUserChatMsgListHistory(data) {
	return request({
		url: "/ai-user-chat-msg/getAiUserChatMsgListHistory",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 智能体-关联文件
export  function getAiKnowledgeFileUser(data) {
	return request({
		url: "/ai-user-chat-msg/getAiKnowledgeFileUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取智能体列表
export  function getAiAppList(data) {
	return request({
		url: "/ai-app/getAiAppList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取智能体列表-详情
export  function getAiAppDetails(data) {
	return request({
		url: "/ai-app/getAiAppDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 创建对话-dify
export function addAiUserChatOneDify(data) {
  return request({
    url: "/ai-user-chat/addAiUserChatOneDify",
    method: "POST",
    data:qs.stringify(data)
  });
}
// 会话记录-详情
export function getAiUserChatDetails(data) {
  return request({
    url: "/ai-user-chat/getAiUserChatDetails",
    method: "POST",
    data:qs.stringify(data)
  });
}
//对话-导出
export function exportAiUserChatMsgWord(data) {
  return request({
    url: "/ai-user-chat-msg/exportAiUserChatMsgWord",
    method: "POST",
    data:qs.stringify(data)
  });
}
//对话-收藏
export function addAiUserChatCollection(data) {
  return request({
    url: "/ai-user-chat-collection/addAiUserChatCollection",
    method: "POST",
    data:qs.stringify(data)
  });
}
//对话-取消收藏
export function deleteAiUserChatCollection(data) {
  return request({
    url: "/ai-user-chat-collection/deleteAiUserChatCollection",
    method: "POST",
    data:qs.stringify(data)
  });
}
//对话-收藏列表
export function getAiUserChatCollectionList(data) {
  return request({
    url: "/ai-user-chat-collection/getAiUserChatCollectionList",
    method: "POST",
    data:qs.stringify(data)
  });
}
//对话-收藏详情
export function getAiUserChatCollectionDetails(data) {
  return request({
    url: "/ai-user-chat-collection/getAiUserChatCollectionDetails",
    method: "POST",
    data:qs.stringify(data)
  });
}
//腾讯云秘钥
export  function getPolicyTxCloudEquityAjTools(data) {
	return request({
		url: "/tx-cloud-file/getPolicyTxCloudEquityAjTools",
		method: "POST",
		data:qs.stringify(data)
	})
}